module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjNWY2MzY4Ij48cGF0aCBkPSJNNjAwLTEyMHYtMTIwSDQ0MHYtNDAwaC04MHYxMjBIODB2LTMyMGgyODB2MTIwaDI0MHYtMTIwaDI4MHYzMjBINjAwdi0xMjBoLTgwdjMyMGg4MHYtMTIwaDI4MHYzMjBINjAwWk0xNjAtNzYwdjE2MC0xNjBabTUyMCA0MDB2MTYwLTE2MFptMC00MDB2MTYwLTE2MFptMCAxNjBoMTIwdi0xNjBINjgwdjE2MFptMCA0MDBoMTIwdi0xNjBINjgwdjE2MFpNMTYwLTYwMGgxMjB2LTE2MEgxNjB2MTYwWiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product-icons/account_tree.svg
// module id = KhQ/
// module chunks = 79